import apiServiceCall from "../services/ApiServiceCall";

export const getTermsOfUse = () => {
  return apiServiceCall().get('/vui/frontend/pages/terminos-y-condiciones').then(({ data }) => data);
}

